import { Box, Divider, Grid, Stack, TextField, ThemeProvider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "../atoms/Header";
import Item from "../atoms/Item";
import TextInput from "../atoms/TextInput";

import { cartAdditionItemsVar } from "../../graphql/reactiveVars";
import { orderStatusLoadingVar } from "../../graphql/reactiveVars";
import { cartItemsVar, clientInfoVar } from "../../graphql/reactiveVars";
import SwipeableDrawer from "../atoms/SwipeableDrawer";
import { useReactiveVar } from "@apollo/client";
import { setClientInfo } from "../../graphql/actions/cartActions";
import React, { useEffect, useState } from "react";
import ProgressBar from "../atoms/ProgressBar";
import { notify } from "../atoms/Notification";
import { useAnalytics } from "../../analytics";
import PageTimer from "../../analytics/PageTimer";
import { themeInput } from "../../assets/theme";
import { formatMobileNumber } from "../atoms/helperFunc/helper";

import ThemedButton from "../atoms/ThemedButton";
import { CURRENT_SCREEN_NAME } from "../../analytics/useAnalytics";

const ConfirmOrderPage = ({ distributor }) => {
  const navigate = useNavigate();
  const cartItems = useReactiveVar(cartItemsVar);
  const clientInfo = useReactiveVar(clientInfoVar);
  const cartAdditionItems = useReactiveVar(cartAdditionItemsVar);
  const orderStatusLoading = useReactiveVar(orderStatusLoadingVar);

  const [error, setError] = useState({});

  const { fireViewScreenEvent, fireConfirmOrderEvent } = useAnalytics();

  useEffect(() => {
    fireViewScreenEvent(CURRENT_SCREEN_NAME.menu_order_details);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onConfirmOrder = async () => {
    const errors = {};

    if (orderStatusLoading) return;
    // if (clientInfo?.mobile_number?.length !== 11) {
    // return console.log(!== "" || !clientInfo?.mobile_number);
    const inputMobile = clientInfo?.mobile_number || "";
    const inputFullName = clientInfo?.full_name || "";
    const inputAddress = clientInfo?.complete_address || "";
    if (!inputMobile) errors.mobile_number = "Please enter a mobile number";
    if (!inputFullName) errors.full_name = "Please enter your full name";
    if (!inputAddress) errors.complete_address = "Please enter your complete address";

    if (errors.mobile_number || errors.full_name || errors.complete_address) return setError(errors);

    if (inputMobile.length !== 11 || !inputMobile.match(/^09/)) {
      errors.mobile_number = "Sundan ang ganitong format: 091XXXXXXX ";
    }

    if (clientInfo?.full_name?.length < 6) {
      errors.full_name = "Kailangan ng full name";
    }
    if (clientInfo?.complete_address?.length < 6) {
      errors.complete_address = "Kailangan ng complete address";
    }

    // const onSuccess = async () => {
    //   firePlaceOrderEvent(clientInfo.mobile_number, totalCost);
    //   await clearData();
    //   await orderStatusLoadingVar(false);
    //   await navigate("/verify-user");
    // };

    if (!cartItems?.length && !cartAdditionItems) {
      return notify({
        message: "Your cart is empty",
        severity: "error",
      });
    }

    if (!Object.values(errors)?.length) {
      setError(errors);
      orderStatusLoadingVar(true);
      await fireConfirmOrderEvent(
        clientInfo.mobile_number,
        clientInfo.store_name,
        clientInfo.full_name,
        clientInfo.complete_address
      );
      navigate(`/${distributor}/verify-user`);
      // sendOrders({ cartItems, clientInfo, cartAdditionItems, onSuccess, totalCost });
    } else {
      setError(errors);
    }
  };

  const onChange = ({ target }) => {
    if (target.name === "mobile_number") {
      if (target.value.length >= 14) {
        return;
      }
      const numbers = target?.value?.match(/\d+/g)?.join("");
      setClientInfo({ ...clientInfo, [target.name]: numbers });
      // setClientInfo({ ...clientInfo, [target.name]: target?.value });
    } else {
      setClientInfo({ ...clientInfo, [target.name]: target.value });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Stack sx={{ minHeight: "100vh", minWidth: "100vw" }} spacing={2}>
      <Header backAction={() => navigate("/cart")} />
      {orderStatusLoading && (
        <Box
          className="bg_gray"
          sx={{
            width: "100vw",
            height: "100vh",
            position: "fixed",
            backgroundColor: "rgba(0, 0, 0, 0.02)",
            backdropFilter: "blur(0.75px)",
            zIndex: 2000,
          }}
        >
          <ProgressBar loading={true} />
        </Box>
      )}

      <Stack px={2.25} spacing={0.25}>
        <Item className="tx700 tx125 ls100">Share contact details</Item>
        <Item className="ls25 lh150" sx={{ fontSize: "15px" }}>
          Kailangan ang iyong mga detalye para ma-confirm ang iyong order.
        </Item>
      </Stack>

      <Stack px={2.25} py={1.75} spacing={2}>
        <InputField
          label="Store Name(Optional)"
          name="store_name"
          placeholder="Ex. Carol’s Sari-Sari"
          value={clientInfo?.store_name || ""}
          onChange={onChange}
          helperText={error.store_name}
        />
        <InputField
          label="Full Name"
          name="full_name"
          placeholder="Anna Cruz"
          value={clientInfo?.full_name || ""}
          onChange={onChange}
          helperText={error.full_name}
        />
        <InputFieldNumber
          label="Mobile number"
          name="mobile_number"
          placeholder="Ex. 0912 345 6789"
          value={formatMobileNumber(clientInfo?.mobile_number || "")}
          onChange={onChange}
          helperText={error.mobile_number}
        />
        <InputField
          label="Complete address"
          name="complete_address"
          placeholder="53-A Sunshine Street, Brgy. Ulan, Quezon City"
          rows={2}
          value={clientInfo?.complete_address || ""}
          onChange={onChange}
          helperText={error.complete_address}
        />
        <Box sx={{ height: 40 }} />
      </Stack>

      <Grid container sx={{ height: 80 }} />
      <Stack spacing={2} sx={{ left: 0, bottom: 18, height: 72.5, position: "fixed", width: "100%" }}>
        <Item>
          <Divider />
        </Item>
        <Item sx={{ px: 2 }}>
          <ThemedButton fullWidth variant="contained" sx={{ fontWeight: 700 }} onClick={onConfirmOrder}>
            <span style={{ fontWeight: 700 }}>Place Order</span>
          </ThemedButton>
        </Item>
      </Stack>
      <SwipeableDrawer />
      <PageTimer />
    </Stack>
  );
};

const InputField = (props) => {
  const { label, name, placeholder, rows = 1, value, onChange, helperText, type } = props;

  return (
    <Stack>
      <Item className="tx600 tx80 ls100 c3">{label}</Item>
      <Item>
        <TextInput
          name={name}
          // onBlur={() => fireUserInputEvent(sessionStorage.getItem("CurrentPage"), value, name)}
          type={type}
          placeholder={placeholder}
          maxRows={rows}
          sx={{ pt: 0.5 }}
          value={value}
          onChange={onChange}
          fullWidth
          helperText={helperText}
          error={!!helperText}
        />
      </Item>
    </Stack>
  );
};

const InputFieldNumber = (props) => {
  const { label, name, placeholder, rows = 1, value, onChange, helperText } = props;

  return (
    <Stack>
      <Item className="tx600 tx80 ls100 c3">{label}</Item>
      <Item>
        <ThemeProvider theme={themeInput}>
          <TextField
            // type="number"
            // type="phone"
            name={name}
            // onBlur={() => fireUserInputEvent(sessionStorage.getItem("CurrentPage"), value, name)}
            placeholder={placeholder}
            maxRows={rows}
            sx={{ pt: 0.5, borderRadius: "20px !important" }}
            value={value}
            onChange={onChange}
            fullWidth
            helperText={helperText}
            error={!!helperText}
          />
        </ThemeProvider>
      </Item>
    </Stack>
  );
};

export default ConfirmOrderPage;
